// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3p1VY","title":"styles_title__2Ae6r"};